// src/utils/mutex/generate-lock-id.ts
function generateLockId({ lockTime, expiration } = {}) {
  let time = typeof lockTime === "number" ? lockTime : Date.now();
  let expires = typeof expiration === "number" ? expiration : 5e3;
  const lockId = `${self.crypto.randomUUID()}+${time + expires}`;
  return lockId;
}

export {
  generateLockId
};
